// extracted by mini-css-extract-plugin
export default {"AppCatalogueProject":"AppCatalogueProject_AppCatalogueProject__7X8fM"};